import {
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    MenuItem,
    Select,
    TextField,
    Typography,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import { ErrorMessage, Field, Form, Formik } from "formik";
  import * as Yup from "yup";
  import { Clear } from "@mui/icons-material";
  import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
  import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
  import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
  import { DatePicker } from "@mui/x-date-pickers/DatePicker";
  import dayjs from "dayjs";
  import moment from "moment";
  
  import { color } from "../../../StyleData/Config";
  import { axiosPrivate } from "../../../axios/axios";
  import { masterAPI } from "../dataConfig";
  import { DesktopDatePicker } from "@mui/lab";
  import { DateTimePicker } from "@mui/x-date-pickers";
import { toast } from "react-toastify";
import ErrorProps from "../../../Component/Errorprops";
  
  const AssetStatusModal = ({ mode, handleCloseClick, editData }) => {
    
    const [loading,setLoading]=useState(false)
  
   
  
    const initialValue = {
      statusName: mode === "Edit" ? editData.statusName : "",
     code: mode === "Edit" ? editData.code : "",
    };
  
    const onSubmit = async(value) => {
      console.log(value);
      setLoading(true)
      const createLink = masterAPI["assetStatus"].create;
      const updateLink = masterAPI["assetStatus"].update;
      if (mode === "Create") {
          
       await axiosPrivate
          .post(`${createLink}`, value)
          .then((res) => {
            console.log(res.data);
            setLoading(false)
            handleCloseClick();
          })
          .catch((e) => {
            setLoading(false)
                       toast.error(e.response.data.failureMessage)
            console.log(e, "createassetStatus");
          });
      } else {
        const updateAC = {
          id: editData.id,
          ...value,
        };
       await axiosPrivate
          .put(`${updateLink}`, updateAC)
          .then((res) => {
            console.log(res.data);
            setLoading(false)
            handleCloseClick();
          })
          .catch((e) => {
            setLoading(false)
             if(e.response.data.FailureMessage)
                      {
                              toast.error("Criticality Code is already exists")
                      }
            console.log(e, "updateassetStatus");
          });
      }
    };
  
    const handleCancel = () => {
      handleCloseClick();
    };
   const validationSchema = Yup.object().shape({
  
    code:Yup.string().required("Code is required"),
    statusName:Yup.string().required("Status Name is required"),
  
   });
    return (
      <Box sx={{ p: color.masterPageDialogPadding }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              color: color.masterDialogTitleColor,
              fontSize: color.masterDialogFontSize,
            }}
          >
           {mode === "Edit"?editData.statusName:"New Asset Status"}
          </Typography>
          <IconButton onClick={handleCancel}>
            <Clear />
          </IconButton>
        </Box>
        <Divider sx={{border:"1px solid rgb(0 0 0 / 17%)",mb:"15px"}} />
        <Formik initialValues={initialValue} validationSchema={validationSchema} onSubmit={onSubmit}>
          {({ handleChange, setFieldValue, values, resetForm }) => (
            <Form>
              <Grid container spacing={"1rem"}>
                 <Grid item xs={12}>
                                <Typography
                                  sx={{
                                    fontWeight: color.labelFontWeight,
                                    mb: color.labelmb,
                                    fontSize: color.labelFont,
                                    color: color.labelColor,
                                  }}
                                >
                                Code
                                </Typography>
                                <Field
                                  as={TextField}
                                  size={"small"}
                                  type="text"
                                  name="code"
                                  placeholder="Enter Code"
                                  fullWidth
                                  sx={{
                                    ".MuiInputBase-input": {
                                      // letterSpacing: "0.2rem",
                
                                      "&::placeholder": {
                                        // color: "green",
                                        opacity: 1,
                                        color: color.placeholderColor,
                                        fontSize: "13px",
                                      },
                                    },
                                  }}
                                />
                                               <ErrorMessage name="code">
                                                {(error) => <ErrorProps>{error}</ErrorProps>}
                                              </ErrorMessage>
                              </Grid>
                <Grid item xs={12} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Asset Status Name
                </Typography>
                  <Field
                    as={TextField}
                    size={"small"}
                    type="text"
                    name="statusName"
                    placeholder="Enter Status Name"
                    fullWidth
                    sx={{
                      ".MuiInputBase-input": {
                        // letterSpacing: "0.2rem",
  
                        "&::placeholder": {
                          // color: "green",
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                    <ErrorMessage name="statusName">
                                                {(error) => <ErrorProps>{error}</ErrorProps>}
                                              </ErrorMessage>
                </Grid>
              
                <Grid
                  container
                  item
                  xs={12}
                  justifyContent={"flex-end"}
                  gap="1rem"
                >
                  <Button
                    onClick={handleCancel}
                    variant="contained"
                    sx={{
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                      ":hover": {
                        backgroundColor: color.TableCancelButton,
                        textTransform: "none",
                        color: color.CancelTextColor,
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type={"submit"}
                    variant="contained"
                    disabled={loading}
                    sx={{
                      
                      textTransform: "none",
                      backgroundColor: loading ? "default" : color.TableButtonColor,
                      "&:hover": {
                        backgroundColor: loading
                          ? "default"
                          : color.buttonDisable,
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>
    );
  };
  
  export default AssetStatusModal;
  